import { createI18nInstance } from "@moodys/cre-cpm.functions.localization"
import locales from "constants/locales"

const authI18n = createI18nInstance(["auth", "agGrid"], locales)

export default authI18n
